export default __webpack_public_path__ + "static/media/checkbox-check-icon.fdb97521.svg";